import { render, staticRenderFns } from "./ImageBackground.vue?vue&type=template&id=7451b2a1&scoped=true"
import script from "./ImageBackground.vue?vue&type=script&lang=js"
export * from "./ImageBackground.vue?vue&type=script&lang=js"
import style0 from "./ImageBackground.vue?vue&type=style&index=0&id=7451b2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7451b2a1",
  null
  
)

export default component.exports